import axios from 'axios'

export default axios.create({
    // baseURL:"https://seahorse-app-odvb2.ondigitalocean.app",
    // baseURL:"http://localhost:8000/",
    baseURL:"https://tracking.offerborn.com/",
})